<template>
  <div id="dash-header">
    <div class="main-header">
      <router-link :to="{ name: 'home' }" class="logo" title="Link to Home" @click.native="closeSidebarMobile()">
        <span class="logo-mini"><b>{{ logoMini }}</b></span>
        <span class="logo-lg">
          <img src="~assets/logo.png">
          <b>{{ header }}</b>
        </span>
      </router-link>
      <nav class="navbar navbar-static-top" role="navigation">
        <a class="sidebar-toggle" data-toggle="offcanvas" role="button" @click="toggleSidebar()" title="Show menu">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <router-link :to="{ name: 'home' }" class="sidebar-home-button" title="Link to Home" @click.native="closeSidebarMobile()">
          <i class="fa fa-home"></i>
        </router-link>
        <div class="navbar-custom-center">{{ subHeader }}</div>
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <template v-for="(value, index) in allLang">
              <li :class="{ active: value === nowLang }" class="cursor-pointer pull-left nav-lang">
                <a @click="switchLang(value)" style="color:#FFF; padding: 10px;">
                  <img class="img-language" :src="require('static/images/flag_' + focusLang(value) + '.png')" style="padding-left:0; width:30px; margin-right:-2px;">
                </a>
              </li>
            </template>
            <template v-if="version >= '2.0.0'">
              <header-announce title="Show announcement"
                              :headerNotiAnnounceTotal="headerNotiAnnounceTotal"
                              :headerNotiAnnounceInfiniteLoading="headerNotiAnnounceInfiniteLoading"
                              :receivedHeaderNotiAnnounceInfiniteLoading="receivedHeaderNotiAnnounceInfiniteLoading"
                              :numberFormat="numberFormat"
                              :nowLang="nowLang"
                              />
              <header-request title="Show request"
                              :headerNotiRequestTotal="headerNotiRequestTotal"
                              :headerNotiRequestInfiniteLoading="headerNotiRequestInfiniteLoading"
                              :receivedHeaderNotiRequestInfiniteLoading="receivedHeaderNotiRequestInfiniteLoading"
                              :numberFormat="numberFormat"
                              :nowLang="nowLang"
                               />
              <header-approve title="Show approve"
                              :headerNotiApprove="headerNotiApprove"
                              :numberFormat="numberFormat"
                              :nowLang="nowLang" />
            </template>
            <header-user title="Show user profile"
              :currentUser="currentUser"
              :nowLang="nowLang"
              :version="version"
              :postLogout="postLogout"
              :profileimg="profileimg" />
            <li title="Setting">
              <a @click="toggleControlsidebar(controlsidebarDisp)" data-toggle="control-sidebar"><i class="fa fa-gears"></i></a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import HeaderAnnounce from 'components/dash/headers/HeaderAnnounce'
import HeaderRequest from 'components/dash/headers/HeaderRequest'
import HeaderApprove from 'components/dash/headers/HeaderApprove'
import HeaderUser from 'components/dash/headers/HeaderUser'

export default {
  name: 'dash-header',
  props: [ 'logoMini', 'header', 'subHeader', 'version', 'currentUser', 'nowLang', 'toggleControlsidebar', 'controlsidebarDisp', 'postLogout', 'headerNotiAnnounceTotal', 'headerNotiAnnounceInfiniteLoading', 'headerNotiRequestTotal', 'headerNotiRequestInfiniteLoading', 'headerNotiApprove', 'receivedHeaderNotiRequestInfiniteLoading', 'receivedHeaderNotiAnnounceInfiniteLoading', 'toggleSidebar', 'profileimg', 'pcDisp', 'closeSidebarMobile', 'allLang', 'focusLang', 'setLang' ],
  components: {
    HeaderAnnounce,
    HeaderRequest,
    HeaderApprove,
    HeaderUser
  },
  methods: {
    switchLang (lang) {
      this.setLang(lang)
      window.location.reload()
    },
    numberFormat (number, decimals = 0) {
      if (number > 0) {
        return parseInt(number).toFixed(decimals).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      }
      return number
    }
  }
}
</script>

<style>
.main-header {
  top: 0px;
}
.navbar{
  max-height: 50px;
}
ul:not(.md-list)>li+li {
     margin-top: 0;
}

</style>



// WEBPACK FOOTER //
// DashHeader.vue?4c8c2d6e